import { RootState } from "../../store";

export const pollingSelector = (state: RootState): boolean =>
  state.accountSetup.polling;
